import mapboxgl from 'mapbox-gl';
/**
 * Fits the map bounds to include all markers in the visible sets.
 * @param map - The map instance.
 * @param visibleSets - An array of MarkerSet objects representing visible sets of markers.
 * @param padding - The padding to apply to the bounds. Defaults to 50.
 */
export const fitBounds = (map, visibleSets, padding) => {
    if (visibleSets.length === 0)
        return;
    const bounds = new mapboxgl.LngLatBounds();
    visibleSets.forEach((markerSet) => {
        markerSet.markers.forEach((markerData) => {
            bounds.extend(markerData.lngLat);
        });
    });
    map.fitBounds(bounds, { padding: padding || 50, maxZoom: 15 });
};
//# sourceMappingURL=fitBounds.js.map